(function(){
    angular
        .module('appback')
        .directive('ngTooltip', tooltip);

        tooltip.$inject = ['$timeout'];
        function tooltip($timeout){
            return {
	            restrict: 'A',
            link: function (scope, element, $attrs, ngModel) {
		            return $timeout(function () {
                        element.hover(function(){
                            console.log("FUNC");
                            // on mouseenter
                            element.tooltip('show');
                        }, function(){
                            // on mouseleave
                            element.tooltip('hide');
                        });
		            });
		        }
          }
      }
})();